import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/jenkins/workspace/shop-fe-prod/apps/shop_public/app/(content)/akit/components/Akit.tsx");
